import React from 'react';

// ⚠️ `children` RENDERS UNDER THE VALUE — added for the month-over-month line on
// the Accounts page. Optional, so every existing caller is unchanged; a card that
// passes nothing looks exactly as it did.
export default function StatCard({ label, value, icon, color = '#3a6ad9', bg = '#eff4ff', onClick, children }) {
  return (
    <div
      onClick={onClick}
      style={{
        backgroundColor: '#fff',
        borderRadius: '12px',
        padding: '18px 20px',
        border: '1px solid #f3f4f6',
        boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'box-shadow 0.15s',
      }}
      onMouseEnter={(e) => { if (onClick) e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)'; }}
      onMouseLeave={(e) => { if (onClick) e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.04)'; }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <p style={{
            fontSize: '11px', fontWeight: '600', color: '#6b7280',
            marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.05em',
          }}>{label}</p>
          <p style={{ fontSize: '26px', fontWeight: '700', color: '#111827', lineHeight: 1 }}>{value ?? 0}</p>
          {children}
        </div>
        {icon && (
          <div style={{
            width: '40px', height: '40px', borderRadius: '10px',
            backgroundColor: bg, display: 'flex', alignItems: 'center',
            justifyContent: 'center', fontSize: '18px', flexShrink: 0,
          }}>{icon}</div>
        )}
      </div>
    </div>
  );
}
